import { render } from "./name.vue?vue&type=template&id=6340cede&scoped=true&ts=true"
import script from "./name.vue?vue&type=script&lang=ts"
export * from "./name.vue?vue&type=script&lang=ts"

import "./name.vue?vue&type=style&index=0&id=6340cede&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6340cede"],['__file',"src/components/inputs/name.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "6340cede"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('6340cede', __exports__)) {
    api.reload('6340cede', __exports__)
  }
  
  module.hot.accept("./name.vue?vue&type=template&id=6340cede&scoped=true&ts=true", () => {
    api.rerender('6340cede', render)
  })

}


export default __exports__